import React from "react";
import { useApp } from "@/context/AppContext";
import { Building2, Lock } from "lucide-react";

// TopBar organisation context. Mid-session multi-org SWITCHING is intentionally disabled during the
// C-Core / legacy migration: switching the C-Core context while the practitioner workspace (matters,
// clients, documents) still hydrates from the legacy organisation would create a client-visible
// split-brain. The active organisation is chosen once (OrgPicker) and shown here as a static chip.
export function OrgSwitcher() {
  const { ccore } = useApp();
  if (!ccore?.ready || !ccore.orgName) return null;
  const multi = (ccore.memberships || []).filter((m) => m.status === "ACTIVE").length > 1;
  return (
    <div
      data-testid="org-switcher-current"
      title={multi ? "Active organisation — switching is disabled during the migration" : ccore.orgName}
      className="flex h-9 items-center gap-2 rounded-lg border border-line bg-card px-3 text-sm"
    >
      <Building2 className="h-4 w-4 text-copper" />
      <span className="max-w-[220px] truncate font-medium text-ink">{ccore.orgName}</span>
      {multi && (
        <span data-testid="org-switch-locked" className="ml-1 flex items-center gap-1 rounded bg-secondary px-1.5 py-0.5 text-[10px] uppercase tracking-wide text-ink-muted">
          <Lock className="h-3 w-3" /> locked
        </span>
      )}
    </div>
  );
}
